// This code should be part of a 'forms' module to use
// the forms abstraction (backend/components/forms/README.md)
// instead of being inside Trainings
import { FormsTypeEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

// Returns the translated form type
export const translateFormType = (type: FormsTypeEnum) => {
  switch (type) {
    case 'satisfaction':
      return i18n.t('trainings.surveys.type.satisfaction')
    case 'effectiveness':
      return i18n.t('trainings.surveys.type.effectiveness')
    case 'knowledge':
      return i18n.t('trainings.surveys.type.knowledge')
    default:
    case 'custom':
      return i18n.t('trainings.surveys.type.custom')
  }
}

type FilterOption = {
  label: string
  value: FormsTypeEnum
}

// Returns the list of options for specified types
// to generate a filter
